export default __webpack_public_path__ + "static/media/short-text-ic.1de4a31b.svg";